import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=7544bf2b&"
import script from "../../../services/admin/category/category-list.js?vue&type=script&lang=js&"
export * from "../../../services/admin/category/category-list.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports